/* mixins/route */
import { Url } from '@/utility/constants'

export default {
    computed: {
        getCurrentPath() {
            return this.$route.fullPath
        },

        getRouteId() {
            let route = this.$route.params.id

            if (route === undefined || route === null) return 0

            return route
        },

        getRouteIdInt() {
            return Number.parseInt(this.getRouteId, 10) || 0
        },

        isNew() {
            return this.getRouteId === Url.NEW
        }
    },

    methods: {
        getUrl(view, route) {
            let url = ''

            if (view) {
                url += `/${view}`
            }

            if (this.$route.params.id != undefined) {
                url += `/${this.$route.params.id}`
            }

            if (route) {
                url += `/${route}`
            }

            if (url === '') {
                url = '/'
            }

            return url
        },

        pushRoute(url) {
            this.$router.push({ path: url }, () => { })
        }
    }
}